import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import "./Student_Detail.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button, Form, Table, Pagination, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  DeleteHost,
  GetAllHost,
  StatusHost,
} from "../../../features/admin/host/slice";
import { useDispatch, useSelector } from "react-redux";
import { IDS } from "../../../utils/IDS";
import {
  DeleteCustomer,
  GetAllCustomer,
  MobileChangeCustomer,
  StatusCustomer,
} from "../../../features/admin/customer/Slice";
import CDeleteModel from "../../common_components/common-modal/delete/CDeleteModel";

const Student_Detail = () => {
  const dispatch = useDispatch();

  const [room, setRoom] = useState(null);
  const [studentName, setStudentName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const navigate = useNavigate();

  const [rdelete, setRDelete] = useState(false);
  const [hostdelete, setHostDelete] = useState(false);

  const handleHostDelete = async () => {
    try {
      await dispatch(DeleteHost(hostdelete)).unwrap();

      setHostDelete(false);
      setSuccess(true);
      await GetAllHost();
    } catch (error) {
      console.error("Delete customer error:", error);

      setHostDelete(false);
      setErr(true);
    }
  };

  const handleDelete = async () => {
    try {
      await dispatch(DeleteCustomer(rdelete)).unwrap();

      setRDelete(false);
      setSuccess(true);
      await GetAllCustomer();
    } catch (error) {
      console.error("Delete customer error:", error);

      setRDelete(false);
      setErr(true);
    }
  };

  const handleCustomerPageChange = (page) => {
    if (page < 1) return;

    fetchCustomer(page);
  };

  const handleReset = () => {
    setRoom(null);
    setStudentName("");
    setFromDate("");
    setToDate("");
    setLocked("");
  };

  const renderPagination = (data, handlePageChange) => {
    if (!data) return null;

    const currentPage = Number(data.current_page || 1);
    const perPage = Number(data.per_page || 10);
    const total = Number(data.total || 0);

    const lastPage = Math.ceil(total / perPage);

    if (lastPage <= 1) {
      return null;
    }

    return (
      <div className="d-flex justify-content-end mt-3">
        <Pagination>
          <Pagination.Prev
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
          />

          {Array.from({ length: lastPage }, (_, index) => {
            const page = index + 1;

            return (
              <Pagination.Item
                key={page}
                active={page === currentPage}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </Pagination.Item>
            );
          })}

          <Pagination.Next
            disabled={currentPage === lastPage}
            onClick={() => handlePageChange(currentPage + 1)}
          />
        </Pagination>
      </div>
    );
  };

  const lockOptions = [
    { value: "", label: "-- All Status --" },
    { value: false, label: "Locked" },
    { value: true, label: "Unlocked" },
  ];
  const [locked, setLocked] = useState(null);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);

  const Host = useSelector((state) => state.host.host);

  const fetchHost = async (page = 1) => {
    await dispatch(
      GetAllHost({
        name: name,
        email: email,
        room_id: room?.value || false,
        page: page,
        per_page: 10,
      }),
    );
  };

  const handleHostPageChange = (page) => {
    if (page < 1) return;

    fetchHost(page);
  };

  useEffect(() => {
    fetchHost();
  }, [name, email, room]);

  const Customer = useSelector((state) => state.customer.customer);

  const fetchCustomer = async (page = 1) => {
    await dispatch(
      GetAllCustomer({
        name: studentName,
        email: email,
        room_id: room?.value === "all" ? "" : room?.value,
        locked: locked?.value ?? "",
        page: page,
        per_page: 10,
      }),
    );
  };
  useEffect(() => {
    fetchCustomer(1);
  }, [studentName, email, room, locked]);

  const handleStatusChange = async (id) => {
    try {
      await dispatch(StatusHost(id)).unwrap();

      setSuccess(true);

      // Refresh the host list
      dispatch(GetAllHost());
    } catch (error) {
      console.error("Status update failed:", error);
      setErr(true);
    }
  };

  const handleCustomerStatusChange = async (id) => {
    try {
      await dispatch(StatusCustomer(id)).unwrap();

      setSuccess(true);

      // Refresh the host list
      dispatch(GetAllCustomer());
    } catch (error) {
      console.error("Status update failed:", error);
      setErr(true);
    }
  };

  const [showMobileChangeModal, setShowMobileChangeModal] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);

  const handleMobileChangeStatus = (id) => {
    setSelectedCustomerId(id);
    setShowMobileChangeModal(true);
  };

  const handleConfirmMobileChange = async () => {
    if (!selectedCustomerId) return;

    try {
      await dispatch(MobileChangeCustomer(selectedCustomerId)).unwrap();

      setShowMobileChangeModal(false);
      setSelectedCustomerId(null);

      setSuccess(true);

      // Refresh customer list
      dispatch(GetAllCustomer());
    } catch (error) {
      console.error("Status update failed:", error);
      setShowMobileChangeModal(false);
      setSelectedCustomerId(null);
      setErr(true);
    }
  };

  // const handleMobileChangeStatus = async (id) => {
  //   try {
  //     await dispatch(MobileChangeCustomer(id)).unwrap();

  //     setSuccess(true);

  //     // Refresh the host list
  //     dispatch(GetAllCustomer());
  //   } catch (error) {
  //     console.error("Status update failed:", error);
  //     setErr(true);
  //   }
  // };

  const formatDateTime = (date) => {
    if (!date) return "-";

    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
      return "-";
    }

    return parsedDate.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  return (
    <section className="Recording_List common_section">
      <div className="common_btn_div">
        <button
          type="button"
          className="orange_btn"
          onClick={() => navigate("/student/detail/create")}
        >
          Create New Student
        </button>
      </div>
      <div className="section_filter_div">
        <div className="row">
          <div className="col-xl-2 col-md-3  col-sm-6">
            <Form.Control
              type="text"
              placeholder="Search by User Name"
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
              className="student_input"
            />
          </div>

          <div className="col-xl-2 col-md-3 col-sm-6">
            <Select
              options={lockOptions}
              value={locked}
              onChange={setLocked}
              placeholder="-- Locked / Unlocked Status --"
              className="common_select"
              classNamePrefix="room"
              isSearchable={false}
            />
          </div>

          {/* SEARCH */}
          <div className="col-xl-2 col-md-3  col-sm-6  col-6 my-auto">
            <button type="button" className="search_btn">
              Search
            </button>
          </div>
          <div className="col-xl-2 col-md-3  col-sm-6  col-6 my-auto">
            <button type="button" className="reset_btn" onClick={handleReset}>
              Reset
            </button>
          </div>
        </div>
      </div>
      <div className="sectin_top">
        <h2 className="section_name">Host Details</h2>
      </div>
      <div className="table-responsive custom-table-wrapper">
        <Table borderless className="custom-table text-center align-middle m-0">
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>UserName</th>
              <th>Email</th>
              <th>Contact No</th>
              <th>Role</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {Host?.data?.length > 0 ? (
              Host?.data.map((val, index) => (
                <tr key={index}>
                  <td>
                    {(Host?.current_page - 1) * Host?.per_page + index + 1}
                  </td>
                  <td>{val?.user_name}</td>
                  <td>{val.email}</td>
                  <td>{val.contact_no || "-"}</td>
                  <td>{val.Role?.name}</td>
                  <td>
                    <div className="green_switch_div">
                      <label className="custom_toggle">
                        <input
                          type="checkbox"
                          checked={Boolean(val?.status)}
                          onChange={() => handleStatusChange(val?.id)}
                        />

                        <span className="toggle_slider"></span>
                      </label>
                    </div>
                  </td>
                  {/* <td>
                    <Form.Check
                      type="switch"
                      id={`custom-switch-${val?.id}`}
                      checked={Boolean(val?.status)}
                      onChange={() => handleStatusChange(val?.id)}
                      label={val?.status ? IDS.ACTIVE : IDS.INACTIVE}
                      className={`custom_status_switch ${
                        val?.status ? "switch_active" : "switch_inactive"
                      }`}
                    />
                  </td> */}

                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      <Button variant="link" className="p-0 action-btn">
                        <FontAwesomeIcon
                          icon={faPenToSquare}
                          className="icon-edit"
                          onClick={() =>
                            navigate(`/host/detail/edit/${val.id}`)
                          }
                        />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="15" className="text-center fw-bold">
                  No Data
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>{" "}
      <div className="result_div">
        <p className="inner_text">
          Showing{" "}
          {Host?.data?.length > 0
            ? (Host.current_page - 1) * Host.per_page + 1
            : 0}{" "}
          to{" "}
          {(Host?.current_page - 1) * Host?.per_page +
            (Host?.data?.length || 0)}{" "}
          of {Host?.total || 0}
        </p>
      </div>{" "}
      {renderPagination(Host, handleHostPageChange)}
      <div className="sectin_top">
        <h2 className="section_name">Student List:</h2>
      </div>
      <div className="table-responsive custom-table-wrapper">
        <Table borderless className="custom-table text-center align-middle m-0">
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>UserName</th>
              <th>User Id</th>
              <th>Reference</th>
              <th>Host</th>
              <th>Password</th>
              <th>Platform</th>
              <th>Change Phone</th>
              <th>ID Locked / Unlocked</th>
              <th>Share ID</th>
              <th>Action</th>
              <th>Log Time</th>
              <th>App version</th>
            </tr>
          </thead>
          <tbody>
            {Customer?.data?.length > 0 ? (
              Customer?.data.map((row, index) => (
                <tr key={index}>
                  <td>
                    {(Customer?.current_page - 1) * Customer?.per_page +
                      index +
                      1}
                  </td>
                  <td className="fw-bold">{row.user_name || "-"}</td>
                  <td className="fw-bold">{row.user_id || "-"}</td>
                  <td className="fw-bold">{row.reference || "-"}</td>
                  <td className="fw-bold">{row.added_by?.user_name || "-"}</td>
                  <td className="fw-bold">{row.show_password || "-"}</td>
                  <td className="fw-bold">{row.model_no || "-"}</td>
                  <td>
                    <Button
                      variant="link"
                      className="p-0 action-btn"
                      onClick={() => {
                        handleMobileChangeStatus(row?.id);
                      }}
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/other/phone_change.png"
                        }
                        className=""
                      />
                    </Button>
                  </td>
                  <td>
                    <p
                      className={
                        row.status ? "green_round_btn" : "red_round_btn"
                      }
                      onClick={() => {
                        handleCustomerStatusChange(row?.id);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {row.status ? "Unlocked" : "Locked"}
                    </p>
                  </td>
                  <td>
                    <Button
                      variant="link"
                      className="p-0 action-btn"
                      onClick={() => {
                        const phone = row?.contact_no;

                        if (!phone) return;

                        const message = encodeURIComponent("Hello");

                        window.open(
                          `https://wa.me/${phone}?text=${message}`,
                          "_blank",
                          "noopener,noreferrer",
                        );
                      }}
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/other/watsapp.png"
                        }
                        className="watsapp_icon"
                        alt="WhatsApp"
                      />
                    </Button>
                  </td>
                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      <Button variant="link" className="p-0 action-btn">
                        <FontAwesomeIcon
                          icon={faPenToSquare}
                          className="icon-edit"
                          onClick={() =>
                            navigate(`/student/detail/edit/${row.id}`)
                          }
                        />
                      </Button>
                      <Button variant="link" className="p-0 action-btn">
                        <FontAwesomeIcon
                          icon={faTrash}
                          className="icon-delete"
                          onClick={() => setRDelete(row?.id)}
                        />
                      </Button>
                    </div>
                  </td>
                  <td className="fw-bold text-nowrap">
                    {formatDateTime(row.log_time) || "-"}
                  </td>
                  <td className="fw-bold">{row.app_version || "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="15" className="text-center fw-bold">
                  No Data
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className="result_div">
        <p className="inner_text">
          Showing{" "}
          {Customer?.data?.length > 0
            ? (Customer.current_page - 1) * Customer.per_page + 1
            : 0}{" "}
          to{" "}
          {(Customer?.current_page - 1) * Customer?.per_page +
            (Customer?.data?.length || 0)}{" "}
          of {Customer?.total || 0}
        </p>
      </div>
      {renderPagination(Customer, handleCustomerPageChange)}
      {rdelete && (
        <CDeleteModel
          show={rdelete}
          setShow={setRDelete}
          action={handleDelete}
        />
      )}
      {hostdelete && (
        <CDeleteModel
          show={hostdelete}
          setShow={setHostDelete}
          action={handleHostDelete}
        />
      )}
      <Modal
        show={showMobileChangeModal}
        onHide={() => setShowMobileChangeModal(false)}
        centered
        className="mobile_change_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Mobile Number</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you really sure you want to change this customer's phone number?
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="no_btn"
            onClick={() => {
              setShowMobileChangeModal(false);
              setSelectedCustomerId(null);
            }}
          >
            No
          </Button>

          <Button className="yes_btn" onClick={handleConfirmMobileChange}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
};

export default Student_Detail;
